import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import moment from "moment";
import {
    ListarProdutosInteresseVendasController,
    TabelaPrecosProdutoVendasController,
} from "../../../Controllers/Vendas/Produtos/ProdutosController";
import { IListaProdutosInteresseRequest } from "../../../Interfaces/Vendas/Produtos/ProdutosInterfaces";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import { saveAs } from "file-saver";

export default function GestaoProdutoVendas() {
    const history = useHistory();

    const {
        value: lstProdutos,
        loading: lstProdutosLoading,
        execute: updateList,
    } = useAsyncEffect(() => ListarProdutosInteresseVendasController(0));

    const {
        execute: TabelaPrecosProdutoVendas,
        loading: TabelaPrecosProdutoVendasLoading,
    } = useAsyncCallback(TabelaPrecosProdutoVendasController);

    function RowEmp(row: IListaProdutosInteresseRequest) {
        const regex = /\/d\/(.*?)(?:\/|$)/;
        const match = row.DS_IMG_EMPREENDIMENTO.match(regex);
        const fileId = match ? match[1] : null;

        return (
            <div className="card p-3">
                <div className="row">
                    <div className="col-md-3">
                        {fileId ? (
                            <div className="d-flex justify-content-center align-items-center w-100 h-100">
                                <img
                                    src={`https://drive.google.com/thumbnail?id=${fileId}&sz=w2000`}
                                    loading="lazy"
                                    alt="Imagem do produto"
                                    className="mb-2 rounded-circle"
                                    style={{
                                        objectFit: "cover",
                                        width: "200px",
                                        height: "200px",
                                    }}
                                />{" "}
                            </div>
                        ) : (
                            <div className="d-flex justify-content-center align-items-center w-100 h-100">
                                Imagem do produto não disponível
                            </div>
                        )}
                    </div>

                    <div className="col-md-9">
                        <div className="card-body">
                            <h3 className="card-title font-weight-bolder">
                                {row.DS_PRODUTO_COMP}
                            </h3>

                            <p className="text-muted">
                                Previsão de Entrega:{" "}
                                {moment(row.DT_PREVISAO_CONCLUSAO).format(
                                    "DD/MM/YYYY"
                                )}
                            </p>

                            <div className="mb-3">
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade de unidades disponíveis
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-success text-white mr-2 py-3 px-6`}
                                    >
                                        {row.NR_UND_DISPONIVEIS}
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade de unidades reservadas
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-success text-white mr-2 py-3 px-6`}
                                        style={{
                                            backgroundColor: "var(--Cobranca)",
                                        }}
                                    >
                                        {row.NR_UNIDADES_RESERVADAS}
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade de unidades vendidas
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-danger text-white mr-2 py-3 px-6`}
                                    >
                                        {row.NR_UNIDADES_VENDIDAS}
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade de unidades permutadas
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-primary text-white mr-2 py-3 px-6`}
                                    >
                                        {row.NR_UNIDADES_PERMUTADAS}
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade de unidades fora de
                                            vendas
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-primary text-white mr-2 py-3 px-6`}
                                        style={{
                                            backgroundColor: "#8e44ad",
                                        }}
                                    >
                                        {row.NR_UNIDADES_FORA_VENDA}
                                    </span>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade de unidades suspensas
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-warning text-white mr-2 py-3 px-6`}
                                    >
                                        {row.NR_UNIDADES_SUSPENSO}
                                    </span>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="ver-info-tooltip">
                                            Quantidade total de unidades
                                        </Tooltip>
                                    }
                                >
                                    <span
                                        className={`badge badge-dark text-white mr-2 py-3 px-6`}
                                    >
                                        {row.NR_UNIDADES}
                                    </span>
                                </OverlayTrigger>
                            </div>

                            <div>
                                <button
                                    className="btn btn-primary mr-2"
                                    onClick={() => {
                                        const rowString = JSON.stringify(row);
                                        const encodedRow =
                                            encodeURIComponent(rowString);
                                        history.push(
                                            ACESSOS.VENDAS.TELAS.MAPA_IMPLANTACAO.DS_LINK(
                                                encodedRow
                                            )
                                        );
                                    }}
                                >
                                    Painel de Implantação
                                </button>
                                <button
                                    className="btn btn-secondary mr-2"
                                    onClick={() => {
                                        TabelaPrecosProdutoVendas(
                                            row.ID_PRODUTO
                                        )
                                            .then((res) => {
                                                if (res) {
                                                    const pdfContent =
                                                        atob(res);

                                                    const arrayBuffer =
                                                        new ArrayBuffer(
                                                            pdfContent.length
                                                        );
                                                    const uint8Array =
                                                        new Uint8Array(
                                                            arrayBuffer
                                                        );
                                                    for (
                                                        let i = 0;
                                                        i < pdfContent.length;
                                                        i++
                                                    ) {
                                                        uint8Array[i] =
                                                            pdfContent.charCodeAt(
                                                                i
                                                            );
                                                    }

                                                    const blob = new Blob(
                                                        [arrayBuffer],
                                                        {
                                                            type: "application/pdf",
                                                        }
                                                    );

                                                    saveAs(
                                                        blob,
                                                        `Tabela de preço - ${row.DS_PRODUTO_COMP}.pdf`
                                                    );
                                                }
                                            })
                                            .finally(() => {
                                                updateList();
                                            });
                                    }}
                                    disabled={TabelaPrecosProdutoVendasLoading}
                                >
                                    {TabelaPrecosProdutoVendasLoading ? (
                                        <>
                                            {" "}
                                            <Spinner size="sm" /> Tabela de
                                            Preços
                                        </>
                                    ) : (
                                        "Tabela de Preços"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription<IListaProdutosInteresseRequest>> = [
        {
            dataField: "DS_PRODUTO_COMP",
            text: "",
            formatter: (c, row) => <RowEmp {...row} />,
        },
    ];

    return (
        <div>
            <Table
                key={`${lstProdutosLoading}-${TabelaPrecosProdutoVendasLoading}`}
                keyField="ID_PRODUTO"
                columns={columns}
                data={lstProdutos ?? []}
                loading={lstProdutosLoading}
            />
        </div>
    );
}
